export default function bytesToSize(bytes) {
  // Handle invalid inputs
  if (bytes === undefined || bytes === null || isNaN(bytes) || bytes === "") {
    return "0 Bytes";
  }
  
  // Convert to number if it's a string
  const numBytes = typeof bytes === 'string' ? parseFloat(bytes) : bytes;
  
  // Handle zero and negative cases
  if (numBytes <= 0) return "0 Bytes";
  
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  
  try {
    const i = parseInt(Math.floor(Math.log(numBytes) / Math.log(1024)));
    if (i >= 0 && i < sizes.length) {
      return (numBytes / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
    }
    return numBytes + " Bytes"; // Fallback for extremely large numbers
  } catch (error) {
    return "0 Bytes"; // Fallback for any calculation errors
  }
}
